import { render, staticRenderFns } from "./CollegeSpecialtyRanking.vue?vue&type=template&id=cf497e7c&scoped=true"
import script from "./CollegeSpecialtyRanking.vue?vue&type=script&lang=js"
export * from "./CollegeSpecialtyRanking.vue?vue&type=script&lang=js"
import style0 from "./CollegeSpecialtyRanking.vue?vue&type=style&index=0&id=cf497e7c&prod&scoped=true&lang=less"
import style1 from "./CollegeSpecialtyRanking.vue?vue&type=style&index=1&id=cf497e7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf497e7c",
  null
  
)

export default component.exports